<template>
    <div>
        <div id="content" class="dashboard">
            <div class="widget-layout main">
                <div
                    class="widget widget-click"
                    @click="$router.push('/patients/servis')"
                >
                    <div class="content green-widget">
                        <div class="header">Pediatri Servis</div>
                        <div class="info">
                            <p class="number">{{ counts.servis }}</p>
                            <p class="footer">HASTA</p>
                        </div>
                    </div>
                </div>
                <div
                    class="widget widget-click"
                    @click="$router.push('/patients/yogunbakim')"
                >
                    <div class="content red-widget">
                        <div class="header">Yoğun Bakım</div>
                        <div class="info">
                            <p class="number">{{ counts.yb }}</p>
                            <p class="footer">HASTA</p>
                        </div>
                    </div>
                </div>
                <div
                    class="widget widget-click"
                    @click="$router.push('/patients/yogunbakim')"
                >
                    <div class="content blue-widget">
                        <div class="header">Yenidoğan YB</div>
                        <div class="info">
                            <p class="number">{{ counts.yd }}</p>
                            <p class="footer">HASTA</p>
                        </div>
                    </div>
                </div>
                <div
                    class="widget widget-click"
                    @click="$router.push('/birthlist')"
                >
                    <div class="content indigo-widget">
                        <div class="header">Bugün Doğan</div>
                        <div class="info">
                            <p class="number">
                                {{ counts.births }}
                            </p>
                            <p class="footer">BEBEK</p>
                        </div>
                    </div>
                </div>

                <div class="welcome">
                    <div class="topbar">
                        <span class="head">{{ welcome.title }}</span>
                        <i class="fa fa-3x fa-info-circle"></i>
                    </div>
                    <div class="doc-page">
                        <div class="doc-page-detail" v-html="welcome.msg"></div>
                    </div>
                </div>

                <div class="doc-list">
                    <div class="head">
                        <i class="fa fa-lg fa-folder-open"></i> Dökümanlar
                    </div>
                    <div class="content">
                        <ul>
                            <li
                                v-for="g in docs"
                                :key="g.id"
                                @click="$router.push('/documents/' + g.id)"
                            >
                                <i class="fa fa-lg fa-file-word"></i>
                                <span class="name">{{ g.baslik }}</span>
                                <span class="folder">{{ g.title }}</span>
                            </li>
                        </ul>
                    </div>
                </div>

                <ul class="activity">
                    <div class="activity-header">
                        <i class="fa fa-lg fa-history"></i>
                        Bugün Yatan Hastalar
                    </div>
                    <div
                        class="content"
                        v-if="
                            patientLastList.servis.length ||
                            patientLastList.yb.length ||
                            patientLastList.yd.length
                        "
                    >
                        <li
                            v-for="p in patientLastList.servis"
                            :key="p.id"
                            @click="$router.push('/patients/servis/' + p.id)"
                        >
                            <i class="fa fa-2x fa-child servis"></i>
                            <div class="patient">
                                <span class="name">{{ p.name }}</span>
                                <span class="tani">{{ p.tanilar }}</span>
                            </div>
                        </li>
                        <li
                            v-for="p in patientLastList.yb"
                            :key="p.id"
                            @click="$router.push('/patients/servis/y/' + p.id)"
                        >
                            <i class="fa fa-2x fa-child yb"></i>
                            <div class="patient">
                                <span class="name">{{ p.name }}</span>
                                <span class="tani">{{ p.tanilar }}</span>
                            </div>
                        </li>
                        <li
                            v-for="p in patientLastList.yd"
                            :key="p.id"
                            @click="
                                $router.push('/patients/yogunbakim/' + p.id)
                            "
                        >
                            <i class="fa fa-2x fa-baby yd"></i>
                            <div class="patient">
                                <span class="name">{{ p.name }}</span>
                                <span class="tani">{{ p.tanilar }}</span>
                            </div>
                        </li>
                    </div>

                    <div
                        class="empty"
                        v-if="
                            !patientLastList.servis.length &&
                            !patientLastList.yb.length &&
                            !patientLastList.yd.length
                        "
                    >
                        <div class="small-empty">
                            <i class="fa fa-info-circle fa-3x"></i>
                            <span>Bugün Yatan Hasta Yok</span>
                        </div>
                    </div>
                </ul>
            </div>
            <div class="widget-layout right">
                <v-calendar
                    is-expanded
                    trim-weeks
                    :attributes="attrs"
                ></v-calendar>
                <div class="mini-widget">
                    <div class="head">
                        <i class="fa fa-lg fa-calculator"></i> Harriet Lane
                    </div>
                    <div class="content">
                        <ul class="drugs">
                            <FsLightbox
                                :toggler="toggler"
                                :sources="drugImages"
                                type="image"
                            />
                            <div class="search-box">
                                <input
                                    type="search"
                                    v-model="drug"
                                    placeholder="Harriet Lane ilaç ara"
                                />
                            </div>
                            <div class="small-empty" v-show="!drugList.length">
                                <i class="fa fa-info-circle fa-3x"></i>
                                <span>İlaç Aratmaya Başlayın</span>
                            </div>
                            <li v-for="d in drugList" :key="d.id" class="drug">
                                <a @click="showDrug(d)"
                                    ><i class="fa fa-pills"></i> {{ d.name }}</a
                                >
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="mini-widget">
                    <div class="head">
                        <i class="fa fa-lg fa-calculator"></i> Persantil
                        Hesaplama
                    </div>
                    <div class="content">
                        <ul class="sablon">
                            <div class="labeledit">
                                <label for="p-dogum">Doğum Tarihi</label>
                                <input
                                    type="date"
                                    v-model="persantil_date"
                                    id="p-dogum"
                                />
                            </div>
                            <div class="labeledit">
                                <label>Cinsiyet</label>

                                <div class="toggle-group">
                                    <label class="selam" for="p-cinsiyet-1">
                                        <input
                                            id="p-cinsiyet-1"
                                            type="radio"
                                            value="1"
                                            class="modern"
                                            v-model="persantil_sex"
                                        />
                                        <span>Erkek</span>
                                    </label>

                                    <label class="selam" for="p-cinsiyet-2">
                                        <input
                                            id="p-cinsiyet-2"
                                            type="radio"
                                            value="2"
                                            class="modern"
                                            v-model="persantil_sex"
                                        />
                                        <span>Kız</span>
                                    </label>
                                </div>
                            </div>
                            <div class="labeledit">
                                <label for="p-kilo">Ağırlık (kg)</label>
                                <input
                                    type="number"
                                    v-model.number="persantil_kg"
                                    id="p-kilo"
                                />
                            </div>
                            <div class="labeledit">
                                <label for="p-boy">Boy (cm)</label>
                                <input
                                    type="number"
                                    v-model.number="persantil_boy"
                                    id="p-boy"
                                />
                            </div>
                            <div class="labeledit">
                                <label for="p-basc">Baş Çevresi (cm)</label>
                                <input
                                    type="number"
                                    v-model.number="persantil_bas"
                                    id="p-basc"
                                />
                            </div>
                            <div class="button-bar">
                                <a
                                    class="btn btn-blue fr"
                                    @click.prevent="getPersantil()"
                                >
                                    <i class="fa fa-lg fa-calculator"></i>
                                    Hesapla
                                </a>
                            </div>
                            <template v-if="persantil[0] != null">
                                <div class="divider"></div>
                                <li class="info" v-show="persantil[0] != null">
                                    <span class="title">Yaş :</span
                                    ><span class="value">
                                        {{ persantil[0] | toYas }}</span
                                    >
                                </li>
                                <li class="info" v-show="persantil[1] != null">
                                    <span class="title">Ağırlık :</span
                                    ><span class="value">
                                        {{ persantil[1] }}</span
                                    >
                                </li>
                                <li class="info" v-show="persantil[2] != null">
                                    <span class="title">Boy :</span
                                    ><span class="value">
                                        {{ persantil[2] }}</span
                                    >
                                </li>
                                <li class="info" v-show="persantil[3] != null">
                                    <span class="title">Baş Çevresi :</span
                                    ><span class="value">
                                        {{ persantil[3] }}</span
                                    >
                                </li>
                            </template>
                        </ul>
                    </div>
                </div>
                <div class="mini-widget">
                    <div class="head">
                        <i class="fa fa-lg fa-calculator"></i> Mayi Hesaplama
                    </div>
                    <div class="content">
                        <ul class="tedavi-tabs">
                            <li
                                @click.prevent="setMayiTabActive(1)"
                                :class="{ active: isMayiTabActive(1) }"
                            >
                                Pediatrik
                            </li>
                            <li
                                @click.prevent="setMayiTabActive(2)"
                                :class="{ active: isMayiTabActive(2) }"
                            >
                                Yenidoğan
                            </li>
                        </ul>
                        <div class="col" v-show="isMayiTabActive(1)">
                            <ul class="sablon">
                                <div class="labeledit">
                                    <label for="p-mayi_kg">Ağırlık (kg)</label>
                                    <input
                                        type="number"
                                        v-model.number="mayi_kg"
                                        id="p-mayi_kg"
                                    />
                                </div>
                                <div class="divider"></div>
                                <li class="info">
                                    <span class="title">İdame (KG Hesabı)</span
                                    ><span class="value">
                                        {{ mayi[0] }} cc/h</span
                                    >
                                </li>
                                <li class="info">
                                    <span class="title">Vücut m2</span
                                    ><span class="value">
                                        {{ mayi[1] }} m2</span
                                    >
                                </li>
                                <li class="info">
                                    <span class="title">1500 cc/m2</span
                                    ><span class="value">
                                        {{ mayi[2] }} cc/h</span
                                    >
                                </li>
                                <li class="info">
                                    <span class="title">2000 cc/m2</span
                                    ><span class="value">
                                        {{ mayi[3] }} cc/h</span
                                    >
                                </li>
                                <li class="info">
                                    <span class="title">2500 cc/m2</span
                                    ><span class="value">
                                        {{ mayi[4] }} cc/h</span
                                    >
                                </li>
                                <li class="info">
                                    <span class="title">3000 cc/m2</span
                                    ><span class="value">
                                        {{ mayi[5] }} cc/h</span
                                    >
                                </li>
                            </ul>
                        </div>
                        <div class="col" v-show="isMayiTabActive(2)">
                            <ul class="sablon">
                                <div class="labeledit">
                                    <label for="p-mayi_kg">Ağırlık (kg)</label>
                                    <input
                                        type="number"
                                        v-model.number="mayi_kg"
                                        id="p-mayi_kg"
                                    />
                                </div>
                                <div class="divider"></div>
                                <li class="info">
                                    <span class="title">Kalsiyum 20 mg/kg</span
                                    ><span class="value"
                                        >Total mayi içine
                                        {{ yd_mayi[0] }} cc</span
                                    >
                                </li>
                                <li class="info">
                                    <span class="title">60 cc/kg</span
                                    ><span class="value"
                                        >{{ yd_mayi[1] }} cc/h (TOTAL
                                        {{ (yd_mayi[1] * 24).toFixed(0) }}
                                        cc)</span
                                    >
                                </li>
                                <li class="info">
                                    <span class="title">70 cc/kg</span
                                    ><span class="value"
                                        >{{ yd_mayi[2] }} cc/h (TOTAL
                                        {{ (yd_mayi[2] * 24).toFixed(0) }}
                                        cc)</span
                                    >
                                </li>
                                <li class="info">
                                    <span class="title">80 cc/kg</span
                                    ><span class="value"
                                        >{{ yd_mayi[3] }} cc/h (TOTAL
                                        {{ (yd_mayi[3] * 24).toFixed(0) }}
                                        cc)</span
                                    >
                                </li>
                                <li class="info">
                                    <span class="title">90 cc/kg</span
                                    ><span class="value"
                                        >{{ yd_mayi[4] }} cc/h (TOTAL
                                        {{ (yd_mayi[4] * 24).toFixed(0) }}
                                        cc)</span
                                    >
                                </li>
                                <li class="info">
                                    <span class="title">100 cc/kg</span
                                    ><span class="value"
                                        >{{ yd_mayi[5] }} cc/h (TOTAL
                                        {{ (yd_mayi[5] * 24).toFixed(0) }}
                                        cc)</span
                                    >
                                </li>
                                <li class="info">
                                    <span class="title">110 cc/kg</span
                                    ><span class="value"
                                        >{{ yd_mayi[6] }} cc/h (TOTAL
                                        {{ (yd_mayi[6] * 24).toFixed(0) }}
                                        cc)</span
                                    >
                                </li>
                                <li class="info">
                                    <span class="title">120 cc/kg</span
                                    ><span class="value"
                                        >{{ yd_mayi[7] }} cc/h (TOTAL
                                        {{ (yd_mayi[7] * 24).toFixed(0) }}
                                        cc)</span
                                    >
                                </li>
                                <li class="info">
                                    <span class="title">130 cc/kg</span
                                    ><span class="value"
                                        >{{ yd_mayi[8] }} cc/h (TOTAL
                                        {{ (yd_mayi[8] * 24).toFixed(0) }}
                                        cc)</span
                                    >
                                </li>
                                <li class="info">
                                    <span class="title">140 cc/kg</span
                                    ><span class="value"
                                        >{{ yd_mayi[9] }} cc/h (TOTAL
                                        {{ (yd_mayi[9] * 24).toFixed(0) }}
                                        cc)</span
                                    >
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from "lodash";
import qs from "qs";
import FsLightbox from "fslightbox-vue";
export default {
    name: "Dashboard",
    components: {
        FsLightbox,
    },
    data() {
        return {
            drug: "",
            drugImages: [],
            toggler: false,
            mayi_kg: null,
            activeMayiTab: 1,
            persantil_sex: 1,
            persantil_date: null,
            persantil_kg: "",
            persantil_boy: "",
            persantil_bas: "",
            persantil: [],
            attrs: [
                {
                    key: "today",
                    highlight: true,
                    dates: new Date(),
                },
            ],
        };
    },
    computed: {
        counts() {
            return this.$store.getters.getCounts;
        },
        welcome() {
            return this.$store.getters.getWelcome;
        },
        docs() {
            return this.$store.getters.getPDocuments;
        },
        patientLastList() {
            return this.$store.getters.getLastYatis;
        },
        drugList() {
            if (this.drug == "") {
                return "";
            } else {
                if (this.drug.length > 2) {
                    let apis = this.$store.getters.getDrugs;
                    let toSearch = this.drug.toLowerCase();
                    let result = _.filter(apis, (o) =>
                        o.name.toLowerCase().includes(toSearch)
                    );
                    return result;
                } else {
                    return "";
                }
            }
        },
        mayi() {
            var kg = Number(this.mayi_kg);
            var m2 = (4 * kg + 7) / (90 + kg);
            var kg_hesap = 0;
            if (kg > 0) {
                switch (true) {
                    case kg <= 10:
                        kg_hesap = (100 * kg) / 24;
                        break;
                    case kg > 10 && kg <= 20:
                        kg_hesap = (1000 + 50 * (kg - 10)) / 24;
                        break;
                    case kg > 20:
                        kg_hesap = (1500 + 20 * (kg - 20)) / 24;
                        break;
                }
            } else {
                m2 = 0;
            }
            return [
                Math.round(kg_hesap),
                Math.round(m2 * 100) / 100,
                Math.round((1500 * m2) / 24),
                Math.round((2000 * m2) / 24),
                Math.round((2500 * m2) / 24),
                Math.round((3000 * m2) / 24),
            ];
        },
        yd_mayi() {
            var kg = Number(this.mayi_kg);
            return [
                ((kg * 20) / 9.3).toFixed(1),
                ((kg * 60) / 24).toFixed(1),
                ((kg * 70) / 24).toFixed(1),
                ((kg * 80) / 24).toFixed(1),
                ((kg * 90) / 24).toFixed(1),
                ((kg * 100) / 24).toFixed(1),
                ((kg * 110) / 24).toFixed(1),
                ((kg * 120) / 24).toFixed(1),
                ((kg * 130) / 24).toFixed(1),
                ((kg * 140) / 24).toFixed(1),
            ];
        },
    },
    methods: {
        // Mayi Tabs
        isMayiTabActive(menuItem) {
            return this.activeMayiTab === menuItem;
        },
        setMayiTabActive(menuItem) {
            this.activeMayiTab = menuItem;
        },
        // Search Drug
        showDrug(ilac) {
            this.drugImages = [];
            let self = this;
            let imgs = ilac.files.split(",");
            imgs.forEach(function (entry) {
                self.drugImages.push(
                    "https://pediatrim.net/HL/HL-" + entry + ".jpg"
                );
            });

            this.toggler = !this.toggler;
        },
        getPersantil() {
            this.$http({
                method: "post",
                url: "api/persantil.php",
                data: qs.stringify({
                    birth: this.persantil_date,
                    sex: this.persantil_sex,
                    kg: this.persantil_kg,
                    boy: this.persantil_boy,
                    bas: this.persantil_bas,
                }),
            }).then((response) => {
                switch (response.data.result) {
                    case 200:
                        this.$snotify.success("Persantil başarıyla hesaplandı");
                        this.persantil = response.data.persantil;
                        break;
                    case 404:
                        this.$snotify.error(
                            "Bilgilerin doğru girildiğinden emin olun"
                        );
                        break;
                }
            });
        },
    },
    created() {
        this.$store.dispatch("fillDash");
    },
};
</script>

<style lang="scss">
#content.dashboard {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    h3.dash {
        margin-top: 10px;
        padding: 10px;
        text-align: center;
        width: 100%;
    }
}

.welcome {
    width: 100%;
    border: 1px solid $gray-400;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    margin: 10px;
    background-image: url("../assets/panel_bg.png");
    .topbar {
        position: relative;
        background-color: transparentize($blue, 0.9);
        color: $blue;
        padding: 10px;
        .head {
            font-size: 24px;
            font-weight: 700;
        }
        svg {
            position: absolute;
            right: 4px;
            top: 4px;
        }
    }
    .doc-page {
        background-color: transparentize($blue, 0.9);
    }
}

.doclist-layout {
    flex-flow: row wrap;
    box-sizing: border-box;
    display: flex;
    flex: 1 1 auto;
    max-width: 100%;
    .pinned-docs {
        display: flex;
        flex-direction: column;
        flex: 1 1 auto;
        max-width: 100%;
        padding: 10px;
        .doc-detail {
            border: 1px solid $gray-400;
            margin-bottom: 10px;
        }
    }
}

.clock {
    width: 100%;
    padding: 20px 0;
    margin: 10px 0;
    background-color: white;
    font-size: 40px;
    font-weight: 500;
    text-align: center;
    text-shadow: 0 0 10px $gray-600, 0 0 10px rgba(10, 175, 230, 0);
    border-radius: 10px;
    border: 1px solid $gray-400;
}

.activity-header {
    margin-top: 20px;
    display: block;
    padding: 7px 0;
    font-weight: 500;
    font-size: 16px;
    svg {
        margin-right: 5px;
    }
}

.mini-widget {
    display: block;
    flex: 1 1 100%;
    margin: 20px 0;
    .head {
        display: block;
        padding: 7px 0;
        font-weight: 500;
        font-size: 16px;
        svg {
            margin-right: 5px;
        }
    }
    .content {
        margin-top: 10px;
        background-color: white;
        border-radius: 5px;
        overflow: hidden;
        box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,
            rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
    }
    ul.sablon {
        list-style-type: none;
        display: flex;
        flex-direction: column;
        padding: 5px;
        .button-bar {
            padding: 5px 0;
        }
        li.info {
            flex: 1 0 auto;
            margin: 3px 5px;
            text-align: left;
            span.title {
                display: inline-block;
                width: 40%;
                font-size: 13px;
                padding: 6px;
                color: $blue;
            }
            span.value {
                display: inline-block;
                font-size: 13px;
                padding: 6px;
                font-weight: 500;
                width: 60%;
            }
        }
    }
    ul.drugs {
        list-style-type: none;
        display: flex;
        flex-direction: column;
        .info-header {
            background-color: $gray-200;
            border-bottom: 1px solid $gray-300;
            font-size: 13px;
            padding: 5px;
            color: $blue;
            font-weight: 500;
        }
        .search-box {
            padding: 8px;
            input {
                width: 100%;
            }
        }
        li.drug {
            flex: 1 0 auto;
            border-bottom: 1px solid $gray-200;
            text-align: left;
            background-color: white;
            a {
                display: block;
                width: 100%;
                font-size: 13px;
                padding: 8px;
                color: $gray-700;
                &:hover {
                    background-color: $gray-200;
                    color: black;
                }
            }
        }
    }
}

.widget-layout {
    flex-flow: row wrap;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    &.main {
        flex: 0 0 calc(100% - 350px);
    }
    &.right {
        flex: 0 0 350px;
    }
    max-width: 100%;
    padding: 10px;
    .doc-list {
        flex: 1 1 40%;
        margin: 20px 10px;
        .head {
            display: block;
            padding: 7px 0;
            font-weight: 500;
            font-size: 16px;
            svg {
                margin-right: 5px;
            }
        }
        .content {
            margin-top: 10px;
            background-color: white;
            border: 1px solid $gray-400;
            ul {
                list-style-type: none;
                li {
                    position: relative;
                    padding: 5px;
                    border-bottom: 1px solid $gray-200;
                    svg {
                        color: $blue;
                        position: absolute;
                        left: 8px;
                        top: 10px;
                    }
                    span.name,
                    span.folder {
                        display: block;
                        padding: 3px 3px 3px 25px;
                    }
                    span.folder {
                        color: $gray-600;
                        font-size: 11px;
                    }
                    &:hover {
                        cursor: pointer;
                        background-color: $gray-100;
                    }
                    &:last-child {
                        border-bottom: 0;
                    }
                }
            }
        }
    }
    ul.activity {
        list-style-type: none;
        margin: 5px 10px 10px 10px;
        flex: 1 1 40%;
        position: relative;
        div.content {
            &::before {
                content: "";
                background-color: $gray-300;
                position: absolute;
                width: 1px;
                left: 13px;
                top: 45px;
                bottom: 15px;
                z-index: -1;
            }
        }
        li {
            &::before {
                content: "";
                background-color: $gray-300;
                position: absolute;
                width: 40px;
                height: 1px;
                left: 15px;
                top: 18px;
                right: 5px;
                z-index: -1;
            }
            position: relative;
            border-radius: 5px;
            margin-top: 10px;
            svg {
                position: absolute;
                left: 4px;
                top: 4px;
                background-color: $background;
                color: $gray-600;
                &.servis {
                    color: $green;
                }
                &.yb {
                    color: $red;
                }
                &.yd {
                    color: $blue;
                }
            }
            .patient {
                padding: 5px;
                margin: 5px 0 5px 35px;
                width: auto;
                background-color: white;
                box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,
                    rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
                border-radius: 5px;
                .name {
                    display: block;
                    font-weight: 500;
                    padding: 2px 0;
                }
                .tani {
                    display: block;
                    font-size: 10px;
                    color: $gray-600;
                }
            }
            &:hover .patient {
                cursor: pointer;
                background-color: $gray-100;
            }
        }
        .empty {
            margin-top: 4px;
        }
    }
}
.widget {
    flex-direction: column;
    box-sizing: border-box;
    display: flex;
    flex: 1 1 25%;
    max-width: 100%;
    position: relative;
    padding: 10px;

    .red-widget {
        color: lighten($red, 10) !important;
        .header {
            border-top: 3px solid darken($red, 15) !important;
        }
    }
    .blue-widget {
        color: lighten($blue, 10) !important;
        .header {
            border-top: 3px solid darken($blue, 15) !important;
        }
    }
    .indigo-widget {
        color: lighten($indigo, 10) !important;
        .header {
            border-top: 3px solid darken($indigo, 15) !important;
        }
    }
    .green-widget {
        color: lighten($green, 10) !important;
        .header {
            border-top: 3px solid darken($green, 15) !important;
        }
    }
    .content {
        border-radius: 5px;
        border: 1px solid $alphaDivider;
        background-color: #fff;
        color: #fff;
        div.header {
            color: black;
            display: block;
            width: 100%;
            font-size: 12px;
            font-weight: 500;
            text-align: center;
            line-height: 32px;
            text-transform: uppercase;
            border-top-left-radius: 5px;
            border-top-right-radius: 5px;
            background-color: white;
            border-bottom: 1px solid $gray-200;
        }
        div.info {
            display: block;
            width: 100%;
            .number {
                font-size: 54px;
                text-align: center;
                font-weight: 500;
                line-height: 50px;
                padding: 10px 0 0 0;
            }
            .footer {
                width: 100%;
                text-transform: uppercase;
                text-align: center;
                line-height: 20px;
                padding: 0 0 10px 0;
                font-size: 12px;
                font-weight: 500;
            }
        }
    }
}

.widget-click {
    cursor: pointer;
    &:hover .content,
    &:hover .content > .header {
        transition: 0.5s;
        color: #fff !important;
    }
    &:hover .red-widget,
    &:hover .red-widget > .header {
        background-color: darken($red, 15) !important;
    }
    &:hover .blue-widget,
    &:hover .blue-widget > .header {
        background-color: darken($blue, 15) !important;
    }
    &:hover .indigo-widget,
    &:hover .indigo-widget > .header {
        background-color: darken($indigo, 15) !important;
    }
    &:hover .green-widget,
    &:hover .green-widget > .header {
        background-color: darken($green, 15) !important;
    }
}
</style>